/* unplugin-vue-components disabled */import { render } from "./SysConfigTabs.vue?vue&type=template&id=5cddfe48&scoped=true"
import script from "./SysConfigTabs.vue?vue&type=script&lang=js"
export * from "./SysConfigTabs.vue?vue&type=script&lang=js"

import "./SysConfigTabs.vue?vue&type=style&index=0&id=5cddfe48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cddfe48"]])

export default __exports__